import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const MapHeader = ({ survey, customizations }) => {
  const navigate = useNavigate();

  const renderLogo = () => {
    const logoType = customizations?.logo?.type || 'default';
    
    switch (logoType) {
      case 'none':
        return null;
      case 'custom':
        if (customizations.logo.customUrl) {
          return (
            <img 
              src={customizations.logo.customUrl}
              alt="Custom Logo"
              className="h-12"
            />
          );
        }
        return null;
      case 'favicon':
        return (
          <img 
            src="/favicon.png"
            alt="Favicon"
            className="h-12"
          />
        );
      case 'default':
      default:
        return (
          <img 
            src="/logo.png"
            alt="OverSizeHub"
            className="h-12"
          />
        );
    }
  };

  return (
    <div className="fixed top-0 left-0 right-0 bg-[#2A2B2E] shadow-sm z-[100] h-16">
      <div className="h-full px-2 flex items-center gap-4">
        <button
          onClick={() => navigate(-1)}
          className="p-2 hover:bg-gray-700 rounded-lg"
        >
          <ArrowLeft className="w-6 h-6 text-white" />
        </button>

        {/* Logo with reduced space */}
        <div className="ml-2">
          {renderLogo()}
        </div>

        <div className="flex-1 ml-4">
          <h1 className="text-xl font-semibold text-white truncate">
            {survey?.name || 'No Survey Selected'}
          </h1>
          {survey?.customerName && (
            <p className="text-sm text-gray-400 truncate">
              {survey.customerName}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default MapHeader;